module.exports = __webpack_public_path__ + "img/mc_symbol.4dfe1b63.svg";